<template>
    <form id="sign-in-form" autocomplete="on" @submit.prevent="validateFields">
        <div class="row">
            <div class="col">
                <slot name="before-email-input" />
                <div class="form-group">
                    <label :class="{'text-danger': errors.has('email') }" for="email">
                        Email
                    </label>
                    <input
                        id="email"
                        v-model="email"
                        v-validate="'email|required'"
                        type="email"
                        autocomplete="on"
                        :class="{ 'is-danger': errors.has('email') }"
                        class="form-control"
                        name="email"
                    >
                    <span v-show="errors.has('email')" class="text-danger">
                        {{ errors.first('email') }}
                    </span>
                </div>
                <password-input
                    v-model="password"
                    v-validate="'required'"
                    class="mb-10"
                    name="password"
                    autocomplete="on"
                    :error="errors.first('password')"
                />
                <div class="form-group">
                    <label for="name" :class="{'text-danger': errors.has('name')}">
                        Name
                    </label>
                    <input
                        id="name"
                        v-model="first_name"
                        v-validate="'required'"
                        type="text"
                        autocomplete="on"
                        class="form-control"
                        :class="{'is-danger': errors.has('name')}"
                        name="name"
                    >
                    <span v-show="errors.has('name')" class="text-danger">
                        {{ errors.first("name") }}
                    </span>
                </div>
                <p v-if="forgotRoute" class="forgot-account">
                    <router-link tabindex="-1" :to="{ name: forgotRoute}">
                        Forgot password?
                    </router-link>
                </p>
                <slot name="before-submit-btn">
                    <div v-if="termsAndConditions" class="form-check terms-conditions">
                        <input
                            id="terms-conditions"
                            v-model="aceptTerms"
                            v-validate="'required'"
                            name="terms-conditions"
                            class="form-check-input"
                            type="checkbox"
                        >
                        <label class="form-check-label" for="terms-conditions">
                            By clicking on "Sign up", you agree to hibooks
                            <router-link
                                class="text-primary"
                                :class="{ 'active' : $route.params.section == 'terms-and-conditions' }"
                                :to="{ name: 'book-insight-legal-term-of-service' }"
                                tabindex="-1"
                            >
                                Terms
                            </router-link> and
                            <router-link
                                class="text-primary"
                                :class="{ 'active' : $route.params.section == 'terms-and-conditions' }"
                                :to="{ name: 'book-insight-legal-privacy-policy' }"
                                tabindex="-1"
                            >
                                Privacy Policy.
                            </router-link>
                        </label>
                    </div>
                </slot>
                <button
                    :disabled="!aceptTerms"
                    :class="['btn',`btn-${formClass}`,'btn-block mt-4 mb-2']"
                    type="submit"
                >
                    <slot name="submit-btn-text">
                        Sign up with email
                    </slot>
                </button>
                <slot name="after-email-input" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "SignUpForm",
    components: {
        passwordInput: () => import(/* webpackChunkName: "password-input"*/ "@c/password-input")
    },
    props: {
        forgotRoute: {
            type: String,
            default: ""
        },
        formClass: {
            type: String,
            default: "primary"
        },
        termsAndConditions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            email: "",
            password: "",
            first_name:"",
            aceptTerms: true
        };
    },
    methods: {
        async validateFields() {
            const isValid = await this.$validator.validate();
            const userData = {
                email_address: this.email,
                password: this.password,
                first_name: this.first_name
            };

            if (this.aceptTerms && isValid) {
                this.$emit("submit-data", userData);
            }
        }
    }
};
</script>
